import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const createPricePerEntry = createAsyncThunk('createPricePerEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertPricePercent`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});

export const fetchPricePerGroupId = createAsyncThunk('fetchPricePerGroupId', async () => {
    try {

        const response = await axios.get(`${baseUrl}?apicall=getPricePercentGroupId`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const fetchPricePerData = createAsyncThunk('fetchPricePerData', async (id) => {
    try {
        const endpoint = id ? `getPricePercentList&pricePerId=${id}` : 'getPricePercentList';
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const deleteSinglePricePer = createAsyncThunk('deleteSinglePricePer', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deletePricePercent&pricePerId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const pricePercentSlice = createSlice({
    name: 'PricePerData',
    initialState: {
        isLoading: false,
        pricePer: null,
        deletePricePer: null,
        grpId: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPricePerData.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPricePerData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.pricePer = action.payload;
        });
        builder.addCase(fetchPricePerData.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteSinglePricePer.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteSinglePricePer.fulfilled, (state, action) => {
            state.isLoading = false;
            state.deletePricePer = action.payload;
        });
        builder.addCase(deleteSinglePricePer.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(fetchPricePerGroupId.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchPricePerGroupId.fulfilled, (state, action) => {
            state.isLoading = false;
            state.grpId = action.payload;
        });
        builder.addCase(fetchPricePerGroupId.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });
    }
});

export default pricePercentSlice.reducer;
